import { useState, useEffect } from "react";
import Header from "../Components/Header";
import { Button, Typography, Box, IconButton, Modal, Grid2 } from "@mui/material";
import styles from "../styles/Especialidades.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../Components/Footer";
import EspecialidadeCard from "../Components/especialidadeCard";
import Agendar from "../Components/Agendar";

const Especialidades = () => {
    const [servicos, setServicos] = useState([]);
    const {servicoName} = useParams();
    const navigate = useNavigate();
  
    useEffect(() => {
      axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-servicos`)
        .then((response) => {
            const data = response.data;

            if (Array.isArray(data)) {
                const sorted = [...data].sort((a, b) => a.name - b.name);
                setServicos(sorted);
            }
        })
        .catch((error) => {
          console.error('Erro na requisição:', error);
        });
        
    },[servicoName]);
    
    const handleClick = (servicoName) => {
        navigate(`/Especialidades/${servicoName}`);
    };

    return(
        <div className="container">
            <Header/>
            <div className="content">
                <div className="banner from-top">
                    <div className="bannerContent">
                        
                        <div className="bannerLeft from-left">
                            <Typography className='bsubtitle from-left' style={{fontFamily:'Inter', color:'#fff', marginBottom:'40px'}}>Nossas especialidades</Typography>
                            <Typography className='bchamada from-left' style={{ transitionDelay: '0.2s' }} variant="h4" sx={{ fontFamily:'Inter',color: 'white', fontWeight: 'bold', fontSize:'56px', marginBottom:'20px' }}>
                            Tratamentos<span style={{ color: '#B08E44' }}> completos</span><br/>para<span style={{ color: '#B08E44' }}> cuidar </span>do seu<span style={{ color: '#B08E44' }}> sorriso. </span>
                            </Typography>
                            <Typography className='from-left' style={{ transitionDelay: '0.3s' }} sx={{marginBottom:'30px', fontFamily:'Inter', color:'#fff', fontSize:'20px'}}>A Odonto Luzzi oferece uma gama completa de<br/> especialidades odontológicas e estéticas.</Typography>
                            <div className="especSeeMore from-left" style={{ transitionDelay: '0.4s' }}>
                                <img src="./images/especialidades/arrow-down.svg"/>
                                <Typography className='bsubtitle' style={{fontFamily:'Inter', color:'#fff', marginLeft:'15px'}}>Veja nossas especialidades</Typography>
                            </div>
                            
                        </div>
                        <div className="bannerRight especBannerRight from-right">
                            <img src="https://odontoluzzi.com.br/images/especialidades/especDrs.png" className="photoBannerEspec"/>
                        </div>
                    </div>
                </div>
                <div className="especContainer">
                    <Grid2 columns={{ xs:4, sm:8, md:12}} className='from-bottom' container spacing={2} justifyContent={'center'}>
                        <Grid2 item>
                            <Grid2 container justifyContent={'center'} spacing={3} width={'100%'} marginLeft={0}>
                                {servicos.map((servico, index) => (
                                    <EspecialidadeCard key={index} title={servico.name} text={servico.descricao} img={servico.foto ? `https://api.sigmasystems.com.br/api/odontoluzzi/uploads/especialidades/${servico.foto}` : 'https://odontoluzzi.com.br/images/padrao/padraoServico.png'} onClick={() => handleClick(servico.name)}/>
                                ))}    
                            </Grid2>                    
                        </Grid2>
                    </Grid2>
                </div>
                <Agendar/>
            </div>
            <Footer/>
        </div>
    )
}
export default Especialidades;